import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { InfosUser } from '@classes/auth/infosUser';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';
import { NavService } from '@services/nav/nav.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChangeMenuNavGuard implements CanActivate {
  userConnected: InfosUser;
  constructor(
    private dataService: DataService,
    private navService: NavService,
    private authSrv: AuthService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.userConnected = this.authSrv.getDecodedToken();
    const application = route.data.application;
    const appsUser = this.authSrv.getDecodedToken()?.application;

    const indexAppUserRoute = appsUser?.findIndex(
      (app) => app.applicationName?.toLowerCase() === application?.toLowerCase()
    );

    switch (application) {
      case 'smarthub':
        let menu = this.navService.navItemsSmartHub;

        if (
          !this.userConnected.role.includes('SmartWaste$SuperAdmin') &&
          !this.userConnected.role.includes('SmartWaste$Admin') &&
          !this.userConnected.role.includes('SmartWaste$User')
        ) {
          menu = menu.filter((lien) => lien.name !== 'SmartWaste');
        }

        if (
          !this.userConnected.role.includes('SmartParking$SuperAdmin') &&
          !this.userConnected.role.includes('SmartParking$Admin') &&
          !this.userConnected.role.includes('SmartParking$User')
        ) {
          menu = menu.filter((lien) => lien.name !== 'SmartParking');
        }

        this.dataService.navLinks.next(menu);

        break;
      case 'Administration':
        if (indexAppUserRoute !== -1) {
          let menu = [...this.navService.navItemsAdminstration];
          if (this.userConnected.role.includes('Administration$Admin')) {
            this.dataService.navLinks.next(
              menu.filter((lien) => lien.name !== 'Customer management')
            );
          } else {
            this.dataService.navLinks.next(menu);
          }
        }
        break;
      case 'smartparking':
        if (indexAppUserRoute !== -1) {
          this.dataService.navLinks.next(this.navService.navItemsSmartParking);
        }
        break;
      case 'smartwaste':
        if (indexAppUserRoute !== -1) {
          this.dataService.navLinks.next(this.navService.navItemsSmartWaste);
        }
        break;

      default:
        break;
    }
    return true;
  }
}
